module.exports = __webpack_public_path__ + "img/logo2000_s.e3387c9c.svg";